import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

/**
 * AuthInterceptor
 * Automatically injects the access token into request headers
 */
export class AuthInterceptor {
  constructor(
    private axiosInstance: AxiosInstance,
    private getAccessToken: () => string | null,
  ) {}

  /**
   * Register the interceptor
   */
  public register(): void {
    this.axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const token = this.getAccessToken();

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }
}
